export default __webpack_public_path__ + "static/karanj-150x150-ec71499d485b8019b28a30ef28dba38b.png";